import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.dev';
import { Auth } from './auth.service';

export interface AuditLog {
  id: number;
  username: string;
  action: string;
  details: string;
  ipAddress: string;
  timestamp: string;
  dateObj?: Date;
}

export interface AuditPage {
  content: AuditLog[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

@Injectable({ providedIn: 'root' })
export class AuditService {
  private apiUrl = `${environment.apiUrl}/audit`;

  constructor(private http: HttpClient, private auth: Auth) {}

  private headers() {
    const token = this.auth.getToken();
    return { headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` }) };
  }

  getLogs(page = 0, size = 15, filters?: { search?: string; username?: string; action?: string }): Observable<AuditPage> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size));
    if (filters?.search) params = params.set('search', filters.search);
    if (filters?.username) params = params.set('username', filters.username);
    if (filters?.action) params = params.set('action', filters.action);
    return this.http.get<AuditPage>(this.apiUrl, { params, ...this.headers() });
  }

  getFilterOptions(): Observable<{ usernames: string[]; actions: string[] }> {
    return this.http.get<{ usernames: string[]; actions: string[] }>(`${this.apiUrl}/filters`, this.headers());
  }
}
